/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FileWorkflowMyStep { 
    stepId: string;
    status: FileWorkflowMyStep.StatusEnum;
    actionType: FileWorkflowMyStep.ActionTypeEnum;
    /**
     * Etiqueta en español: Revisión, Aprobación…
     */
    actionTypeLabel: string;
    stepOrder: number;
    /**
     * Paso en curso y flujo en curso: puede actuar ya
     */
    isMyTurn: boolean;
}
export namespace FileWorkflowMyStep {
    export type StatusEnum = 'pending' | 'in_progress' | 'completed' | 'rejected' | 'cancelled';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        InProgress: 'in_progress' as StatusEnum,
        Completed: 'completed' as StatusEnum,
        Rejected: 'rejected' as StatusEnum,
        Cancelled: 'cancelled' as StatusEnum
    };
    export type ActionTypeEnum = 'review' | 'approve' | 'authorize' | 'acknowledge' | 'seen';
    export const ActionTypeEnum = {
        Review: 'review' as ActionTypeEnum,
        Approve: 'approve' as ActionTypeEnum,
        Authorize: 'authorize' as ActionTypeEnum,
        Acknowledge: 'acknowledge' as ActionTypeEnum,
        Seen: 'seen' as ActionTypeEnum
    };
}


